import React from "react";
import {Box, Divider, Grid, styled, Typography} from "@mui/material";
import {Facebook, Instagram} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import useIsMobile from "../hooks/useIsMobile.hook";

const Title = styled(Typography)(() => ({
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: 2,
  paddingBottom: '16px'
}));

const Text = styled(Typography)(() => ({
  fontSize: 16,
  fontWeight: 300,
}));

const Strong = styled('strong')(() => ({
   fontWeight: 600,
}));

const FooterContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  padding: '0 16px',
  background: '#f3f3f3',
}));


const Link = styled('a')(() => ({
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  color: '#000',
  gap: 6,
  paddingBottom: '8px',
}));

const Footer = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  return (
    <FooterContainer>
      <Box maxWidth={1200} width="100%">
        <Box sx={{ pb: isMobile ? 0 : 10 }} display="flex" justifyContent="center">
          <Grid container sx={{ padding: '56px 0' }} width="100%" spacing={4}>
            <Grid item xs={12} sm={6} md={4}>
              <Title>
                {t('bank')}
              </Title>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4}}>
                <Strong>{t('receiver')}:</Strong>
                <Text> Gemeinschaft Freier Christusgemeinden e.V.</Text>
              </div>
              <Text><Strong>IBAN:</Strong> DE63 3626 4325 6256 4233 34</Text>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Title>
                {t('address')}
              </Title>
              <Text>Sachsenweg 19 59073 Hamm</Text>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Title>
                {t('contact')}
              </Title>
              <Text>Hamm-Leuchtturm@gfc.org </Text>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Title>
                {t('networks')}
              </Title>
              <Link href="https://facebook.com" target="_blank">
                <Facebook/>
                <Text>Facebook</Text>
              </Link>
              <Link href="https://www.instagram.com/cgw.hamm?igsh=MWJ6Z2F5bHNycDhlOA==" target="_blank">
                <Instagram/>
                <Text>Instagram</Text>
              </Link>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        <Box sx={{ padding: '34px 0' }}>
          <Typography fontSize={isMobile ? 12 : 18}>
            © 2023 Gemeinschaft Freier Christusgemeinden e.V. Alle Rechte vorbehalten.
          </Typography>
        </Box>
      </Box>
    </FooterContainer>
  );
};

export default Footer;
